import { createFileRoute } from '@tanstack/react-router';

import { TemplateLoading } from '@/_pages/competitors/template/template-loading';

export const Route = createFileRoute('/_private/competitors/_template')({
  pendingComponent: TemplateLoading,
});
